export default {
    REPORT_STORE: 'https://shop.aventica.tech',
};
